import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 border-t border-background-800/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-compass-3-fill text-lg text-background-950"></i>
                </div>
                <span className="text-base font-heading font-bold text-foreground-100">成人导航</span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed max-w-xs">
                成人导航为您提供最全面的成人内容导航服务，精选优质成人网站、影视资源、娱乐平台一站式导航，安全便捷高效。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    服务条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-mail-line text-sm"></i>
                  <span>contact@example.com</span>
                </li>
                <li className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-shield-check-line text-sm"></i>
                  <span>安全 · 便捷 · 高效</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {currentYear} 成人导航. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-600">18+ 成人内容，未成年人请勿浏览</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}